import Dummy from '@/pages/Dummy/Pages/Dummy.vue'
import swa from '@/pages/__TEMPLATES/Components/SweetAlert.vue'
import Layout from '../pages/Layouts/FrontendLayout.vue'

import { getDummyPage, getFrontendPage as getPage } from './utils.js'

const dummy_routes = [
  {
    path: 'dummy',
    name: 'Dummy',
    component: Dummy,
    children: [
      {
        path: 'inputs',
        components: { default: getDummyPage('Inputs') },
      },
      {
        path: 'swa',
        name: 'Inputs',
        component: swa,
      },
    ],
  },
]

const routes = [
  {
    path: '/',
    redirect: '/pricing',
    name: 'Home',
  },
  {
    path: '/',
    component: Layout,
    children: [
      ...dummy_routes,
      {
        path: 'dashboard',
        name: 'Dashboard',
        components: { default: getPage('Dashboard') },
      },
      {
        path: 'pricing',
        name: 'Pricing',
        components: { default: getPage('Pricing') },
      },
      {
        path: 'pricing-strategies',
        name: 'Pricing Strategies',
        components: { default: getPage('PricingStrategy') },
      },
      {
        path: 'events',
        name: 'Calendar & Events',
        components: { default: getPage('Events') },
      },
      {
        path: 'allotment-restrictions',
        name: 'Allotment & Restrictions',
        components: { default: getPage('Allotment') },
      },
      {
        path: 'reporting',
        name: 'Reporting',
        components: { default: getPage('Reporting') },
      },
      {
        path: 'pax-grid',
        name: 'Pax Grid',
        components: { default: getPage('PaxGrid') },
      },
      {
        path: 'pricing-rules',
        name: 'Pricing Rules',
        components: { default: getPage('PricingRules') },
      },

      {
        path: 'allotment-rules',
        name: 'Allotment Rules',
        components: { default: getPage('AllotmentRules') },
      },
      {
        path: 'groups-list',
        name: 'Groups List',
        components: { default: getPage('GroupsList') },
        meta: {
          requiereSpecificRole: true,
          roleList: ['group', 'group_read'],
        },
      },
      {
        path: 'groups-list/group/:id',
        name: 'Group edit',
        components: { default: getPage('Groups') },
        meta: {
          requiereSpecificRole: true,
          roleList: ['group', 'group_read'],
        },
      },
      {
        path: 'groups-list/group',
        name: 'Group',
        components: { default: getPage('Groups') },
        meta: {
          requiereSpecificRole: true,
          roleList: ['group', 'group_read'],
        },
      },
    ],
  },
]

export default routes
